import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useT } from '../../../../../../../_metronic/i18n/Metronici18n'
import { IconPaths, IconSize } from '../../../../../../../_metronic/helpers/enumsUI'
import { KTSVG } from '../../../../../../../_metronic/helpers/components/KTSVG'
import { CustomSelect, IOption } from '../../../../../../components/Input/CustomSelect'
import { TableFilter, TableFilters } from '../../../../../../components/Table/TableFilters'
import { useAcoesModelo } from '../../../core/useProtocoloAcoes'
import { useEmpresaDaTela } from '../../../core/useEmpresaDaTela'
import { CLASSE_LINK_OUTLINE } from '../../../core/classeLinkOutline'

/**
 * Barra do card da tabela: empresa (só quando o usuário tem mais de uma) e o link para a área do
 * modelo da plataforma (só para quem a gerencia). Sem nenhum dos dois, a barra não aparece.
 */
export const ProtocolosTriagemListHeader: FC = () => {
  const { t } = useT()
  const { idEmpresa, empresas, selecionarEmpresa } = useEmpresaDaTela()
  const { acoesModelo } = useAcoesModelo()

  const escolheEmpresa = empresas.length > 1
  const linkModeloPlataforma = acoesModelo.podeGerenciarModelo && (
    <Link className={CLASSE_LINK_OUTLINE} to='/apps/protocolos-triagem/modelo-plataforma'>
      <span className='me-2 d-flex align-items-center' aria-hidden='true'>
        <KTSVG path={IconPaths.Gear} size={IconSize.ExtraSmall} />
      </span>
      {t('protocolos_triagem.modelo_plataforma.titulo', undefined, 'Modelo da plataforma')}
    </Link>
  )

  if (!escolheEmpresa && !linkModeloPlataforma) return null

  const opcoesEmpresa: IOption[] = empresas.map((empresa) => ({
    label: empresa.nome,
    value: empresa.id,
  }))

  return (
    <div className='card-header border-0 pt-6'>
      <TableFilters actions={linkModeloPlataforma || undefined}>
        {escolheEmpresa && (
          <TableFilter
            label={t('protocolos_triagem.empresa', undefined, 'Empresa')}
            htmlFor='empresa-protocolo'
            wide
          >
            <CustomSelect
              inputId='empresa-protocolo'
              options={opcoesEmpresa}
              value={opcoesEmpresa.find((opcao) => opcao.value === idEmpresa)}
              onChange={(opcao: IOption | null) => opcao && selecionarEmpresa(Number(opcao.value))}
            />
          </TableFilter>
        )}
      </TableFilters>
    </div>
  )
}
